import { GoogleMap, OverlayView } from '@react-google-maps/api'
import { GoogleMapsLoader } from 'components/GoogleMapsLoader'
import { PropertyMapCard } from 'components/Property'
import mapTheme from 'data/map-theme.json'
import { ComponentType, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { buildBounds, getPixelPositionOffset } from 'utils/maps'
import { Bubble } from './bubble'

const Wrapper = styled.div`
  height: 100%;
  width: 100%;

  .map {
    height: 100%;
    width: 100%;
  }
`

const DownArrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  top: 100%;
  left: 50%;
  box-sizing: border-box;
  border: 8px solid black;
  border-color: #ffffff transparent transparent transparent;
  transform: translateX(-50%);
`

interface Props {
  properties: any[]
}

export const GMap: ComponentType<Props> = ({ properties }) => {
  const map = useRef<google.maps.Map>()
  const [uuid, setUuid] = useState()

  const [ready, setReady] = useState(false)
  const [bounds, setBounds] = useState<google.maps.LatLngBounds>()

  useEffect(() => {
    if (ready) {
      setBounds(buildBounds(properties))
      setUuid(undefined)
    }
  }, [ready, properties])

  useEffect(() => {
    if (map.current && bounds) {
      map.current.fitBounds(bounds)
    }
  }, [bounds])

  return (
    <Wrapper>
      <GoogleMapsLoader>
        <GoogleMap
          mapContainerClassName="map"
          options={{
            mapTypeControl: false,
            streetViewControl: false,
            styles: mapTheme as any,
          }}
          onDragStart={() => {
            setUuid(undefined)
          }}
          onLoad={(googleMap) => {
            map.current = googleMap
            setReady(true)
          }}
        >
          {properties.map((property) => {
            if (!map.current) {
              return null
            }

            const position = new google.maps.LatLng(property.location.coordinates[1], property.location.coordinates[0])

            return (
              <OverlayView
                key={property.uuid}
                position={position}
                mapPaneName={uuid === property.uuid ? OverlayView.FLOAT_PANE : OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={getPixelPositionOffset}
              >
                <div className="position-relative cursor-pointer">
                  {uuid === property.uuid ? (
                    <PropertyMapCard property={property} />
                  ) : (
                    <Bubble
                      property={property}
                      onClick={() => {
                        map.current!.panTo(position)
                        setUuid(property.uuid)
                      }}
                    />
                  )}
                  {property.pin && <DownArrow />}
                </div>
              </OverlayView>
            )
          })}
        </GoogleMap>
      </GoogleMapsLoader>
    </Wrapper>
  )
}
